"use client"

import { ExperimentFlags } from "data/experiment"
import { useFeatureFlag } from "hooks"
import { useEffect } from "react"

export const DigiohLightboxScript = () => {
  const [loading, showDigiohPopup] = useFeatureFlag(
    ExperimentFlags.SHOW_DIGIOH_POPUP,
    "0"
  )

  useEffect(() => {
    if (!loading && !!showDigiohPopup) {
      const script = document.createElement("script")
      script.src =
        "https://www.lightboxcdn.com/vendor/5b411e43-b610-40f4-9f96-7be310aa03a8/lightbox_inline.js"
      script.async = true
      script.type = "text/javascript"
      script.id = "digioh-lightbox-popup"
      document.head.appendChild(script)

      return () => {
        document.getElementById("digioh-lightbox-popup")?.remove()
      }
    }
  }, [loading, showDigiohPopup])

  return null
}
